/* Copyright 2013 - 2024 Waiterio LLC */
import { css } from '@emotion/react'

export default css`
  label: d-lg-block;
  @media (min-width: 992px) {
    display: block !important;
  }
`
